import { AccordionEvent, DropdownEvent } from "../event";
import { Component, ComponentConfiguration } from "../base";

export type AccordionConfiguration = ComponentConfiguration & {
    group?: string,
    title?: string,
    prevent_link?: boolean,
    speed?: number,
};

export class Accordion extends Component
{
    protected configuration: AccordionConfiguration;

    protected accordionsInGroup: NodeListOf<HTMLElement>;

    protected animationSpeed: number;

    protected contentContainer: HTMLElement;

    protected cssEasing: string;

    protected expandedClass: string;

    protected groupAttr: string;

    protected groupName: string;

    protected isAnimating: boolean;

    protected state: { expanded: boolean, animating: boolean, };

    protected toggler: HTMLElement;

    constructor(...configurations: AccordionConfiguration[])
    {
        let defaults: AccordionConfiguration = {
            content_element: ".c-Accordion__content",
            group: null,
            title: "",
            prevent_link: true,
            speed: 300,
        };

        super(defaults, ...configurations);
    }

    public build(): this
    {
        super.build();

        // this.__handleAccordionExpand = this.__handleAccordionExpand.bind(this);
        // this.__handleAccordionCollapse = this.__handleAccordionCollapse.bind(this);
        this.handleAccordionToggle = this.handleAccordionToggle.bind(this);

        this.groupAttr = "data-accordion-group";
        this.groupName = this.getAttribute(this.groupAttr);
        this.toggler = this.querySelector(".c-Accordion__toggler"); //c-Accordion__header
        this.contentContainer = this.querySelector(".c-Accordion__content-container");
        this.animationSpeed = this.configuration.speed;
        this.cssEasing = "cubic-bezier(0, 0, 0.2, 1)";
        this.isAnimating = true;
        this.expandedClass = "c-Accordion--expanded";

        if (this.groupName)
        {
            this.accordionsInGroup = document.querySelectorAll(`[${this.groupAttr}="${this.groupName}"]`);
        }

        this.state = {
            expanded: false,
            animating: false,
        };

        this.initState();
        this.attachEvents();

        return this;
    }

    public expand(animate = true): this
    {
        this.state.animating = true;

        //Content : Set getHeight, add activeClass
        const clientHeight = this.getTargetHeight(this.contentContainer);
        this.contentContainer.style.visibility = "visible";
        this.element.classList.add(this.expandedClass);

        if (animate)
        {
            //Animation
            this.contentContainer.style.overflow = "hidden";
            this.contentContainer.style.transition = `${this.animationSpeed}ms ${this.cssEasing}`;
            this.contentContainer.style.maxHeight = (clientHeight || "1000") + "px";
            setTimeout(() =>
            {
                this.contentContainer.style.maxHeight = "none";
                this.contentContainer.style.transition = "";
                this.contentContainer.style.overflow = "";
                this.state.animating = false;
            }, this.animationSpeed);
        }
        else
        {
            //No Animation
            this.contentContainer.style.maxHeight = "none";
            this.contentContainer.style.overflow = "";
            this.state.animating = false;
        }

        this.state.expanded = true;

        this.trigger(AccordionEvent.EXPAND);
        // this.collapseOtherInGroup();
        return this;
    }

    public collapse(animate = true): this
    {
        if (!animate)
            this.state.animating = true;

        //Content : Set getHeight, remove activeClass
        this.element.classList.remove(this.expandedClass);
        this.contentContainer.style.overflow = "hidden";
        this.contentContainer.style.maxHeight = this.contentContainer.clientHeight + "px";

        setTimeout(() =>
        {
            this.contentContainer.style.maxHeight = "0px";
        }, 5);

        if (animate)
        {
            //Animation
            this.contentContainer.style.transition = `${this.animationSpeed}ms ${this.cssEasing}`;
            setTimeout(() =>
            {
                this.contentContainer.style.transition = "";
                this.state.animating = false;
                this.contentContainer.style.visibility = "hidden";
            }, this.animationSpeed);
        }
        else
        {
            //No Animation
            this.state.animating = false;
            this.contentContainer.style.visibility = "hidden";
        }

        this.state.expanded = false;
        this.trigger(AccordionEvent.COLLAPSE);

        return this;
    }

    protected initState(): this
    {
        this.contentContainer.style.overflow = "hidden";
        this.contentContainer.style.maxHeight = "none";
        this.state.expanded = this.element.classList.contains(this.expandedClass);

        if (this.state.expanded)
        {
            this.expand(false);
        }
        else
        {
            this.collapse(false);
        }

        return this;
    }

    protected getTargetHeight(targetEl): number
    {
        if (!targetEl) return;

        const cloneEl = targetEl.cloneNode(true);
        const parentEl = targetEl.parentNode;

        if (!parentEl) return;

        cloneEl.style.maxHeight = "none";
        cloneEl.style.opacity = "0";
        parentEl.appendChild(cloneEl);
        const clientHeight = cloneEl.clientHeight;
        parentEl.removeChild(cloneEl);
        return clientHeight;
    }

    protected attachEvents(): this
    {
        if (this.toggler)
            this.toggler.addEventListener("click", this.handleAccordionToggle);

        return this;
    }

    protected handleAccordionCollapse(event): void
    {
        event.preventDefault();
        this.collapse();
    }

    protected handleAccordionExpand(event): void
    {
        event.preventDefault();
        this.expand();
    }

    protected handleAccordionToggle(event): void
    {
        event.stopPropagation();
        event.preventDefault();
        /*
        if (this.configuration.prevent_link)
        {
        }*/

        if (this.state.expanded)
        {
            this.collapse();
        }
        else
        {
            this.expand();
        }
    }
}
